import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "ui";

interface AthleteLimitDialogProps {
  athleteLimit: number;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function AthleteLimitDialog(props: AthleteLimitDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{t("athleteLimit.dialogTitle")}</DialogTitle>
          <DialogDescription>
            {t("athleteLimit.dialogMessage", {
              athleteLimit: props.athleteLimit,
            })}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button asChild>
            <Link to="/settings/billing">{t("athleteLimit.changePlan")}</Link>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
